"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const components_1 = require("./components");
const CardContext = (0, react_1.createContext)({ noPadding: false });
function CardSection({ children, className, separated, }) {
    const cardContext = (0, react_1.useContext)(CardContext);
    const { noPadding, title } = cardContext;
    const style = (0, react_1.useMemo)(() => (0, app_1.css) `
      ${noPadding && components_1.styles.section.noOuterPadding(noPadding)}
      ${!title && components_1.styles.section.noTopPadding}
      ${separated && components_1.styles.section.separated}
    `, [noPadding, separated, title]);
    return ((0, jsx_runtime_1.jsx)(components_1.Section, Object.assign({ className: className, css: style }, { children: children })));
}
exports.Card = (0, react_1.forwardRef)((_a, ref) => {
    var { title, className, noPadding, children } = _a, rest = __rest(_a, ["title", "className", "noPadding", "children"]);
    const contextValue = (0, react_1.useMemo)(() => ({ noPadding: noPadding !== null && noPadding !== void 0 ? noPadding : false, title }), [noPadding, title]);
    const style = (0, react_1.useMemo)(() => (0, app_1.css) `
          ${noPadding && components_1.styles.card.noInnerPadding}
        `, [noPadding]);
    return ((0, jsx_runtime_1.jsx)(CardContext.Provider, Object.assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsxs)(components_1.CardWrap, Object.assign({}, rest, { ref: ref, className: className, css: style }, { children: [(0, jsx_runtime_1.jsx)(components_1.Title, { title: title }), children] })) })));
});
exports.Card.Section = CardSection;
exports.Card.Title = components_1.Title;
